import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';

import { DateInputFieldComponent } from '../date-input-field/date-input-field.component';

@Component({
  selector: 'datetime-input-field',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, DatePickerModule, FloatLabelModule],
  templateUrl: './datetime-input-field.component.html',
  styleUrls: ['./datetime-input-field.component.scss'],
})
export class DatetimeInputFieldComponent extends DateInputFieldComponent {
  @Input() label = '';
  @Input() hourFormat: '12' | '24' = '24';
  /** Minute step for the time spinner — defaults to 30-minute intervals. */
  @Input() stepMinute = 30;
  /** Emitted when the date-picker panel is closed (blur / select / outside click). */
  @Output() closed = new EventEmitter<void>();
}
